import BaseElement from './BaseElement';
import HealthscoreCockpitV2 from '../Components/Profile/HealthscoreCockpitV2';
class HealthscoreCockpitV2Element extends BaseElement {
    constructor() {
        super(...arguments);
        this.element = HealthscoreCockpitV2;
    }
}
export const loadHealthscoreCockpitV2Element = () => {
    customElements.define('healthscore-cockpit-v2', HealthscoreCockpitV2Element);
};
